import { pickBy } from 'lodash'
import { Nullable } from 'types/global'
import { parse } from 'qs'

export const extractQueryParams = (url: Nullable<string>): Record<string, string> => {
  if (!url) return {}
  if (url.indexOf('?') < 0) return {}
  const result = parse(url.slice(url.indexOf('?') + 1))
  return pickBy(result, val => typeof val === 'string') as { [key: string]: string }
}
